module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "添加配置",
      "width": "35%",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "element-loading-text": "请稍等···"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "configInfo",
    attrs: {
      "model": _vm.configInfo,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "KEY",
      "prop": "key"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.configInfo.key),
      callback: function($$v) {
        _vm.$set(_vm.configInfo, "key", $$v)
      },
      expression: "configInfo.key"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "VALUE",
      "prop": "value"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.configInfo.value),
      callback: function($$v) {
        _vm.$set(_vm.configInfo, "value", $$v)
      },
      expression: "configInfo.value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c316538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/add_config_dialog.vue
// module id = 1404
// module chunks = 1